//const ImgSrc = 'http://192.168.5.3:88/';
const ImgSrc = 'http://118.190.100.182:9099';


/**
 * @return {string}
 */
export function NaviLanguage(){
    var lang = navigator.language||navigator.userLanguage;//常规浏览器语言和IE浏览器
    lang = lang.substr(0, 2);//截取lang前2位字符
    if(lang === 'zh'){
        lang = "zh_CN"
    }else{
        lang = 'en_US'
    }
    return lang;
}



export default {
    ImgSrc,
}



// WEBPACK FOOTER //
// ./src/assets/js/global.js